import { createSlice } from "@reduxjs/toolkit";
import uuidv4 from "uuid/v4";

const initialState = {
    "id" : uuidv4(),
    "theme": 'light'
}
const themeListner = createSlice({
    name:'themeListner',
    initialState,
    reducers:{
        updateTheme: (_state,payload)=>{
               return {
                "id" : uuidv4(),
                "theme": payload.payload
               }
        }
    }
});

export default themeListner.reducer
export const updateTheme = themeListner.actions.updateTheme